module.exports = __webpack_public_path__ + "static/media/55_000032.c2745f5d.jpg";